import React, {createContext, useCallback, useContext, useMemo, useState} from "react";
import "./toast.css";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((opts) => {
    const id = Math.random().toString(36).slice(2);
    const t = { id, type: opts.type || "info", title: opts.title || "", msg: opts.msg || "", ttl: opts.ttl ?? 4200 };
    setToasts(s => [...s, t]);
    // auto remove
    setTimeout(() => setToasts(s => s.filter(x => x.id !== id)), t.ttl);
  }, []);

  const api = useMemo(() => ({
    info:  (msg, o={}) => push({ type:"info",  title:o.title||"Info",    msg, ...o }),
    ok:    (msg, o={}) => push({ type:"ok",    title:o.title||"Done",    msg, ...o }),
    warn:  (msg, o={}) => push({ type:"warn",  title:o.title||"Warning", msg, ...o }),
    error: (msg, o={}) => push({ type:"error", title:o.title||"Error",   msg, ...o }),
  }), [push]);

  return (
    <ToastCtx.Provider value={api}>
      {children}
      <div className="toast-wrap" aria-live="polite" aria-atomic="true">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type}`} role="status">
            <div className="toast-title">{t.title}</div>
            {t.msg && <div className="toast-msg">{t.msg}</div>}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  return useContext(ToastCtx);
}
